export default "__VITE_ASSET__BadevPT1__"